import { mapState } from 'vuex';
import {
  AddressingType,
  ApartmentDTO,
  EntrancePlantDetailDTO,
} from '@/../client-generator/generated-clients/plants';
import { Options, Vue } from 'vue-class-component';

@Options({
  name: 'ApartmentItem',
  props: {
    apartment: {
      type: ApartmentDTO,
      required: true,
    },
  },
  computed: {
    ...mapState(['currentEntrancePlant']),
  },
  emits: ['edit-apartment', 'delete-apartment'],
})
export default class ApartmentItem extends Vue {
  currentEntrancePlant!: EntrancePlantDetailDTO;
  apartment!: ApartmentDTO;

  get gates() {
    let apartmentGates: string[] = [];
    this.currentEntrancePlant.gates?.forEach((gate) => {
      if (
        gate.name !== undefined &&
        this.apartment.apartmentId !== undefined &&
        gate.apartments?.includes(this.apartment.apartmentId)
      ) {
        apartmentGates.push(gate.name);
      }
    });

    return apartmentGates;
  }

  get isCallingCode () {
    return this.currentEntrancePlant.addressingType === AddressingType.DirectCall_Alphanumeric ||
      this.currentEntrancePlant.addressingType === AddressingType.DirectCall_NumbersOnly;
  }

  get isBRFA() {
    return this.currentEntrancePlant.addressingType === AddressingType.BuildingRiserFloorApartment;
  }

  get apartmentName() {
    if (this.isBRFA) {
      return this.apartment.code?.replaceAll('|', ' ');
    }

    if (this.isCallingCode) {
      return this.apartment.code + ' | ' + this.apartment.name;
    }

    return this.apartment.name;
  }

  editApartment() {
    this.$emit('edit-apartment', this.apartment);
  }

  deleteApartment() {
    this.$emit('delete-apartment', this.apartment.apartmentId);
  }
}
